export function createTemplate(templateText) {
	const dom = new DOMParser().parseFromString(templateText, 'text/html');
	return dom.querySelector('template');
}
